import getApi from '../../api'
import { deserializeOrdoclicUrlResponse, OrdoclicUrlResource } from './mapper/ordoclicUrl.mapper'

export const getPatientOrdoclicUrl = (patientId: number) =>
  getApi()
    .post<OrdoclicUrlResource>('/external_eprescription/init', { patientId })
    .then(deserializeOrdoclicUrlResponse)
